import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-and-guides',
  templateUrl: './help-and-guides.component.html',
  styleUrls: ['./help-and-guides.component.scss']
})
export class HelpAndGuidesComponent implements OnInit {
  sectionTitle = 'Help & Guides'
  HGSectionTitles = {
    firstTitle: 'About Zenplans',
    scdTitle: 'Lorem Ipsum Dolor'
  }
  
  HGFirstDataCollapse =  [
    { 
      id: 'data-collapse1' , 
      title: 'Lorem ipsum dolor sit amet.', 
      data: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.' 
    },

    { 
      id: 'data-collapse2' , 
      title: 'Lorem ipsum dolor sit amet.', 
      data: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.' 
    },
  ]

  HGScdDataCollapse = {
      id: 'data-collapse3',
      title: 'Lorem ipsum dolor sit amet.', 
      data: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.' 
    }
  
  

  
  

  constructor() { }

  ngOnInit() {
  }

}
